import { createSelector } from 'reselect';

export const getRatings = state => state.firestore.ordered.ratings;

export const getRatingsCount = createSelector(
  [getRatings],
  ratings => {
    return ratings ? ratings.length : 0;
  }
);

export const getAverageRatings = createSelector(
  [getRatings],
  ratings => {
    if (!ratings || !ratings.length) {
      return 5;
    }
    let total = 0;
    ratings.forEach(rating => {
      total = total + rating.rating;
    });

    return total / ratings.length;
  }
);



// WEBPACK FOOTER //
// ./src/store/selectors/ratings.js